<template>
    <div class="cms_subpagerightcont_outer">
        <GrcDB ref="GRCDB"></GrcDB>

        <div class="cms_subpagerightcont_hirek_cont">
            <div class="cms_subpagerightcont_hirek_title" v-html="HirekTitle" />

            <a v-for="(hiritem, hirindex) in HIREK" :key="hirindex" class="cms_subpagerightcont_hirek_item" v-html="hiritem.HtmlContent" :href="hiritem.Alias">
            </a>

            <a href="hirek" class="cms_subpagerightcont_hirek_osszes_link">Összes hír<i class="fal fa-angles-right" style="margin-left:8px;"></i></a>
        </div>

        <div class="cms_subpagerightcont_hirek_cont">
            <div class="cms_subpagerightcont_hirek_title" v-html="BlogTitle" />

            <a v-for="(blogitem, blogindex) in BLOG" :key="blogindex" class="cms_subpagerightcont_hirek_item" v-html="blogitem.HtmlContent" :href="blogitem.Alias">
            </a>

            <a href="blog" class="cms_subpagerightcont_hirek_osszes_link">Összes bejegyzés<i class="fal fa-angles-right" style="margin-left:8px;"></i></a>
        </div>

    </div>
</template>

<script>

import GrcDB from './GrcDB.vue'

export default {
  name: 'grccms_subpage_rightcont',
  components: {
    GrcDB,
  },

  data () {
        return {
            HirekTitle: "",
            BlogTitle: "",
            HIREK:[],
            BLOG:[],
        }
  },
  model: {

  },  
  methods:{

    async Init()
    {
        var QP = {
            sSessionID: "[APPSESSIONID]",
            sAlias: GRCAPP_GetParameters.ALIAS,
        };
        var Q;
        await this.$refs.GRCDB.GetData("CMS_GetRightCont", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            console.log(Q);
            return;
        }

        this.HirekTitle = Q.DATA[0].HirekTitle;
        this.BlogTitle = Q.DATA[0].BlogTitle;
        this.HIREK = Q.HIREK;
        this.BLOG = Q.BLOG;



    },

  },
  created()
  {
    
  },

 mounted()
 {
    this.Init();
 },


}


</script>


<style scoped>


</style>
